module.exports = __webpack_public_path__ + "snapshot-15a1a7b9f5d53860227742d2005ba268.png";